import type { ReactElement } from 'react';
import { SitePageShell } from '@/shared/ui';
import { MyPageHeader } from '@/widgets/my-page-header';
import { MyPageNav } from '@/widgets/my-page-nav';
import { MyPageOverview } from '@/widgets/my-page-overview';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 마이페이지 홈 — 요약·최근 견적·최근 디자인·바로가기(/my). 큰 "My Page" 머리 아래 왼쪽(좁은 화면은 위) 메뉴와 본문을 놓는다. */
export const MyHomePage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
    <MyPageHeader />
    <div className="mt-8 grid gap-10 sm:mt-12 lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[15rem_minmax(0,1fr)] xl:gap-20">
      <MyPageNav activeId="home" />
      <MyPageOverview />
    </div>
  </SitePageShell>
);
